import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

const ExtendedLink = ({ to, children, location, className }) => {
    return <Link to={{
        pathname: to,
        search: location.search
    }} className={className}>{children}</Link>
}

export default withRouter(ExtendedLink)